export enum AuthServiceAppId {
  REX_CRM = "rex_crm",
  REX_PM = "rex_pm",
}
